<dashboardnav>
    <cradua-delivery-type
    [deliverytypes]="deliverytypes$ | async"
    (deliverytype)="onSubmitDeliveryType($event)"
    (deleteDeliveryTypeEvent)="onDeleteDeliveryType($event)"
    *ngIf="(isLoadingDeliveryType$ | async ) === false"
    >
  </cradua-delivery-type>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingDeliveryType$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
